import { Option } from '~/components/Select';
import * as moment from 'moment';

// https://shippo.atlassian.net/wiki/spaces/DM/pages/103776346/BILLING+INVOICEITEM+TYPE+Data+Definition
export enum InvoiceItemType {
  LABEL_PAYMENT = 'Label Payment',
  LABEL_FAILURE = 'Label Failure',
  LABEL_SURCHARGE = 'Label Surcharge',
  LABEL_REFUND = 'Label Refund',
  REBATE = 'Rebate',
  ONE_OFF_CREDIT = 'One Off Credit',
  LEGACY_CHARGE = 'Legacy Charge',
  LEGACY_REFUND = 'Legacy Refund',
  TRACK_FEE = 'Track Fee',
  ADDRESS_VALIDATION_FEE = 'Address Validation Fee',
  BRANDING = 'Branding',
  MULTI_USER_LOGIN = 'Multi User Login',
  INSURANCE_FEE = 'Insurance Fee',
  LABEL_FEE = 'Label Fee',
  SUBSCRIPTION_PLAN_FEE = 'Subscription Plan Fee',
  POSTAGE_PRICE = 'Postage Price',
  PROMO_CODE_CREDIT = 'Promo Code Credit',
  LABEL_PRICE_TRUE_UP_CHARGE = 'Label Price True Up Charge',
  LABEL_PRICE_TRUE_UP_REFUND = 'Label Price True Up Refund',
  PREAUTH_CAPTURE = 'Preauth Capture',
  LABEL_PAYMENT_ADJUSTMENT = 'Label payment adjustment',
  LABEL_REFUND_ADJUSTMENT = 'Label refund adjustment',
}

export const InvoiceItemTypeMap: Record<string, InvoiceItemType> = {
  LABEL_PAYMENT: InvoiceItemType.LABEL_PAYMENT,
  LABEL_FAILURE: InvoiceItemType.LABEL_FAILURE,
  LABEL_SURCHARGE: InvoiceItemType.LABEL_SURCHARGE,
  LABEL_REFUND: InvoiceItemType.LABEL_REFUND,
  REBATE: InvoiceItemType.REBATE,
  ONE_OFF_CREDIT: InvoiceItemType.ONE_OFF_CREDIT,
  LEGACY_CHARGE: InvoiceItemType.LEGACY_CHARGE,
  LEGACY_REFUND: InvoiceItemType.LEGACY_REFUND,
  TRACK_FEE: InvoiceItemType.TRACK_FEE,
  ADDRESS_VALIDATION_FEE: InvoiceItemType.ADDRESS_VALIDATION_FEE,
  BRANDING: InvoiceItemType.BRANDING,
  MULTI_USER_LOGIN: InvoiceItemType.MULTI_USER_LOGIN,
  INSURANCE_FEE: InvoiceItemType.INSURANCE_FEE,
  LABEL_FEE: InvoiceItemType.LABEL_FEE,
  SUBSCRIPTION_PLAN_FEE: InvoiceItemType.SUBSCRIPTION_PLAN_FEE,
  POSTAGE_PRICE: InvoiceItemType.POSTAGE_PRICE,
  PROMO_CODE_CREDIT: InvoiceItemType.PROMO_CODE_CREDIT,
  LABEL_PRICE_TRUE_UP_CHARGE: InvoiceItemType.LABEL_PRICE_TRUE_UP_CHARGE,
  LABEL_PRICE_TRUE_UP_REFUND: InvoiceItemType.LABEL_PRICE_TRUE_UP_REFUND,
  PREAUTH_CAPTURE: InvoiceItemType.PREAUTH_CAPTURE,
  LABEL_PAYMENT_ADJUSTMENT: InvoiceItemType.LABEL_PAYMENT_ADJUSTMENT,
  LABEL_REFUND_ADJUSTMENT: InvoiceItemType.LABEL_REFUND_ADJUSTMENT,
};

// https://shippo.atlassian.net/wiki/spaces/DM/pages/103481392/API+INVOICEITEM+Data+Model
export type JSONInvoiceItem = {
  id: number;
  object_created: string;
  invoice_item_type: string;
  description: string;
  is_credit: boolean;
  is_paid: boolean;
  amount: number;
  currency: string;
  object_purpose: string;
  provider_name?: string;
  tracking_number?: string;
  transaction: Maybe<{
    object_id: string;
    object_created: string;
    object_updated: string;
    tracking_number: string;
    carrier: string;
    servicelevel_name: string;
    servicelevel_token: string;
    carrier_account: string;
    order: string;
  }>;
  order: Maybe<{
    order_number: string;
    shop_app: string;
    order_status?: string;
    object_id?: string;
    created_at?: string;
  }>;
  invoice: Maybe<{
    object_id: string;
    object_created: string;
    number: string;
    total_currency: string;
    total_amount: string;
    paid: string;
    status: string;
  }>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  meta?: Maybe<any>;
};

export default interface InvoiceItem {
  id: number;
  objectCreated: moment.Moment;
  invoiceItemType: string;
  description: string;
  shopApp?: string;
  orderNumber?: string;
  carrier?: string;
  trackingNumber?: string;
  invoiceObjectId?: string;
  invoiceNumber?: string;
  isCredit: boolean;
  isPaid: boolean;
  amount: number;
  currency: string;
  objectPurpose: string;
}

export function fromJSON(jsonInvoiceItem: JSONInvoiceItem): InvoiceItem {
  return {
    id: jsonInvoiceItem.id,
    objectCreated: moment(jsonInvoiceItem.object_created),
    invoiceItemType: jsonInvoiceItem.invoice_item_type,
    description: jsonInvoiceItem.description,
    shopApp: jsonInvoiceItem.order?.shop_app,
    orderNumber: jsonInvoiceItem.order?.order_number,
    carrier: jsonInvoiceItem.transaction?.carrier || jsonInvoiceItem.provider_name,
    trackingNumber: jsonInvoiceItem.transaction?.tracking_number || jsonInvoiceItem.tracking_number,
    invoiceObjectId: jsonInvoiceItem.invoice?.object_id,
    invoiceNumber: jsonInvoiceItem.invoice?.number,
    isCredit: jsonInvoiceItem.is_credit,
    isPaid: jsonInvoiceItem.is_paid,
    amount: jsonInvoiceItem.amount,
    currency: jsonInvoiceItem.currency,
    objectPurpose: jsonInvoiceItem.object_purpose,
  };
}

export type InvoiceFiltersFormData = {
  startDate: Maybe<moment.Moment>;
  endDate: Maybe<moment.Moment>;
  invoiceStatus: Maybe<Option>;
  invoiceItemType: Maybe<Option>;
  storeName: Maybe<Option>;
  carrierAccount: Maybe<Option>;
};
